var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.gameType == '3' && _vm.$store.state.integralFlag)?_c('div',{staticClass:"levelIcon"},[_c('div',{staticClass:"task_user_level_text_icon",class:_vm.rankClass},[_vm._v(_vm._s(_vm.level))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }